<template>
    <div class="d-flex flex-wrap flex-stack my-5">
        <router-link to="/module/slider" class="btn btn-primary align-self-center">
            <span class="svg-icon svg-icon-2">
                <inline-svg src="/media/icons/duotune/arrows/arr021.svg" />
            </span>
            {{ $t("pages.module.sliderGroup.title") }}
        </router-link>
    </div>
    <custom-table
        :title="sprintf($t('pages.module.sliderItem.titlePattern'), [sliderGroup.alias ?? ''])"
        :subTitle="$t('pages.module.sliderItem.subTitle')"
        selectableRows
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        @action="handleClickAction"
        @selectableRows="handleSelectedRow"
        @changeTable="handleTableChange">
        <template v-slot:title="{ row: record }">
            {{ resolveDatum(record.translations, this.$root.defaultLanguage.id, 'language_id').title }}
        </template>
        <template v-slot:startDate="{ row: record }">
            {{ record.start_date ? $moment(record.start_date).format("DD.MM.YYYY - HH:mm:ss") : "-" }}
        </template>
        <template v-slot:endDate="{ row: record }">
            {{ record.end_date ? $moment(record.end_date).format("DD.MM.YYYY - HH:mm:ss") : "-" }}
        </template>
        <template v-slot:status="{ row: record }">
            <span :class="record.active ? 'badge-light-success': 'badge-light-danger'" class="badge">{{ record.active ? $t('common.active') : $t('common.passive') }}</span>
        </template>
        <template v-slot:created_at="{ row: record }">
            {{ record.created_at ? $moment(record.created_at).format("DD.MM.YYYY - HH:mm:ss") : "-" }}
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <router-link :to="'/module/slider/'+sliderGroupID+'/item/save/' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                     <span class="svg-icon svg-icon-3">
                         <inline-svg src="/media/icons/duotune/art/art005.svg" />
                     </span>
                </router-link>
                <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteRecord([record.id])">
                    <template #reference>
                        <a class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                            <span class="svg-icon svg-icon-3">
                                <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                            </span>
                        </a>
                    </template>
                </el-popconfirm>
            </div>
        </template>
    </custom-table>
</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "product",
    components: {
        CustomTable
    },
    data(){
        return {
            fields: [
                {
                    name: this.$t("common.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.module.sliderItem.cols.title"),
                    scopedSlots: {customRender: "title"}
                },
                {
                    name: this.$t("pages.module.sliderItem.cols.startDate"),
                    scopedSlots: {customRender: "startDate"}
                },
                {
                    name: this.$t("pages.module.sliderItem.cols.endDate"),
                    scopedSlots: {customRender: "endDate"}
                },
                {
                    name: this.$t("common.sort"),
                    key: "sort",
                    class: ""
                },
                {
                    name: this.$t("common.status"),
                    scopedSlots: {customRender: "status"}
                },
                {
                    name: this.$t('common.createdAt'),
                    scopedSlots: {customRender: "created_at"}
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            selectedRowKeys: [],
            sliderGroup: {}
        }
    },
    computed: {
        sliderGroupID() {
            return this.$route.params.id;
        },
        table() {
            return this.$store.state.module.slider.item.table;
        }
    },
    created() {
        if (!this.sliderGroupID || !(this.sliderGroupID > 0)) {
            this.$router.push({
                path: "/module/slider"
            });
        }
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("pages.module.sliderItem.title"), [this.$t("menu.moduleManagement"), this.$t("pages.module.sliderGroup.title") ]);

        if (this.sliderGroupID && this.sliderGroupID > 0) {
            this.loadSliderGroup();

            this.$store.dispatch('module/slider/item/get', {
                page: {},
                filterData: {
                    group_id: this.sliderGroupID,
                    sort: 'created_at:desc'
                }
            });
        }
    },
    methods:{
        loadSliderGroup() {
            this.axios.get(this.endpoints['module_slider_group'] + '/' + this.sliderGroupID).then((response) => {
                this.sliderGroup = response.data.data;
            })
        },
        deleteRecord(id){
            this.$store.dispatch("module/slider/item/delete", {
                id: id
            }).then((successDeleted) => {
                this.selectedRowKeys = this.selectedRowKeys.filter(x => !successDeleted.includes(x));
            });
        },
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                case "new":
                    this.$router.push({
                        path: "/module/slider/" + this.sliderGroupID + "/item/save"
                    });
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },
        refreshTable(){
            this.$store.dispatch("module/slider/item/refresh");
        },
        handleTableChange(pagination, filterData) {
            this.$store.dispatch("module/slider/item/get", {
                page: pagination,
                filterData: Object.assign({
                    group_id: this.sliderGroupID,
                    sort: 'created_at:desc'
                }, filterData)
            });
        },
        handleSelectedRow(record){
            this.selectedRowKeys = record;
        }
    }
}
</script>

<style scoped>

</style>